/**
 * Created by smizrahi on 8/1/16.
 */

import WebService from '../../services/WebService'
import EQError from '../../utils/EQError'
export const WEBSERVICE_EXT = '/ws/4';

export default class ConfigWebService extends WebService {
    constructor(url, folder) {
        super();
        if (!url || !folder) {
            throw new EQError('Folder or url parameter missing', 1203);
        } else {
            this.confVersion = 16;
            this.url = url + WEBSERVICE_EXT + '/mscoreconfiguration';
            this.folder = folder;
        }
    }

    /**
     * Get the configuration from server
     *
     * @param config
     * @param coupon
     * @returns {Promise} XML Configuration
     */
    get(config, coupon = null) {
        let parameters = {};
        parameters.configurationVersion = this.confVersion;

        if (config) {
            parameters.scenarioVersion = config.confVersion;
            parameters.groupId = config.groupId;
        } else {
            parameters.scenarioVersion = -1;
            parameters.groupId = 0;
        }

        parameters.dqaInstallationDirectory = this.folder;
        if (coupon) parameters.couponCode = coupon;

        return this.post(this.url, parameters);
    }

    /**
     * Return the configuration version from the server
     *
     * @returns {number} Configuration version
     */
    getWebserviceVersion() {
        return this.confVersion;
    }
}


// WEBPACK FOOTER //
// ./js/core/configuration/service/ConfigWebService.js